import './css/style.scss';
import './i18n/i18n';

import { b2x } from '@b2x/react/src';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { BestPrice } from './BestPrice';
import { Button, ButtonVariant } from './Button';
import { CartSku } from './CartSku';
import { Container } from './Container';
import { en } from './i18n/locales/en';
import { it } from './i18n/locales/it';
import { IconName, IconSize } from './Icon';
import { OffcanvasHeader } from './Offcanvas';
import { ThemeColor } from './pages/TemplatePage';
import { PriceBlock } from './PriceBlock';
import { ProductTile, ProductTileBasicInfo, ProductTileExtraInfo } from './ProductTile';
import { reportWebVitals } from './reportWebVitals';
import { ServiceContactsSubpage } from './ServiceContactsSubpage';

b2x.init<ThemeColor, ButtonVariant, IconName, IconSize>({
  analytics: {
    facebook: {
      debug: true,
      sendPageView: true,
    },
  },
  api: {
    apiKey: 'GIHEADBAABHBGJIGBFAJBD',
    productPopulate: {
      alternativeImages: true,
      assembledComponents: {
        componentSkus: {
          price: true,
          sku: {
            attributes: true,
            measurement: true,
            price: true,
            product: {
              attributeGroups: true,
              attributes: true,
              brand: true,
            },
          },
        },
      },
      attributeGroups: true,
      attributes: true,
      brand: true,
      priceRange: true,
      skus: {
        alternativeImages: true,
        attributes: true,
        measurement: true,
        price: true,
      },
      variantProducts: {
        skus: {
          attributes: true,
          measurement: true,
          price: true,
        },
      },
    },
    productTilePopulate: {
      assembledComponents: {
        componentSkus: {
          price: true,
          sku: {
            attributes: true,
            measurement: true,
            price: true,
          },
        },
      },
      brand: true,
      priceRange: true,
      skus: {
        attributes: true,
        measurement: true,
        price: true,
      },
      variantProducts: {
        skus: {
          measurement: true,
          price: true,
        },
      },
    },
    sessionOptions: {
      populate: {
        cart: {
          packs: {
            cartSkus: {
              sku: {
                attributes: true,
                product: {
                  attributes: true,
                },
              },
            },
          },
          shippingProfile: true,
        },
        customer: true,
        wishlist: { products: true, skus: { product: true } },
      },
    },
  },
  defaultButtonVariant: 'primary',
  enableCientSideComingSoonManagement: true,
  form: {
    buttons: {
      cancel: {
        defaultVariant: 'outline-primary',
      },
      submit: {
        defaultVariant: 'primary',
      },
    },
  },
  i18n: {
    en: en,
    it: it,
  },
  icons: {
    arrow: {
      left: 'arrow-left',
    },
    cart: 'cart',
    close: 'close',
    configurator: 'filter-by',
    download: 'download',
    info: 'info',
    logout: 'logout',
    passwordToggle: {
      hidden: 'hidden',
      visible: 'visible',
    },
  },
  preRelease: true,

  preselectFirstAvailableSku: true,
  projectName: 'arexons',
  ui: 'bs5',
  variants: {
    AccountOffcanvas: 'A',
    AddressFieldset: 'A',
    BestPrice: BestPrice,
    Button: Button,
    CartAddressFromAddressBookForm: 'A',
    CartAddressesForm: 'A',
    CartSku: CartSku,
    ChangePasswordForm: 'A',
    Container: Container,
    CustomerAddressForm: 'A',
    CustomerForm: 'B',
    InvoiceFieldset: 'A',
    LoginForm: 'A',
    OffcanvasHeader: OffcanvasHeader,
    OrderDetails: 'A',
    OrderGuestForm: 'A',
    PriceBlock: PriceBlock,
    ProductStickyFooter: 'B',
    ProductTile: ProductTile,
    ProductTileBasicInfo: ProductTileBasicInfo,
    ProductTileExtraInfo: ProductTileExtraInfo,
    ServiceContactsSubpage: ServiceContactsSubpage,
    SimpleSearchForm: 'A',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <b2x.router.BrowserRouter>
      <b2x.ModalsContext>
        <App />
      </b2x.ModalsContext>
    </b2x.router.BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
